import React from 'react'
import './releaseTag.scss'

interface Props {
  variant: string
  name?: string
}

function ReleaseTag({ variant, name }: Props) {
  if (name === 'undefined') {
    return <></>
  }

  return (
    <div className={`releaseTag-container__${variant}`}>
      <p className={`releaseTag-text__${variant}`}>{name || ''}</p>
    </div>
  )
}

export default ReleaseTag
